// extracted by mini-css-extract-plugin
export default {"wrapper":"AddCompany_wrapper__3oeuM","phone__field":"AddCompany_phone__field__1sYVR","phone__field__label":"AddCompany_phone__field__label__vcUJ2","error":"AddCompany_error__xUAwx"};